interface CheckademicLogoProps {
  height?: string;
  primaryColor?: string;
  accentColor?: string;
  textColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const CheckademicLogo = ({
  height = '50px',
  primaryColor = 'var(--primary-color)',
  accentColor = 'var(--secondary-color)',
  textColor = 'var(--text-primary)',
  className,
  style,
}: CheckademicLogoProps) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    ...style,
  };

  const textStyle: React.CSSProperties = {
    fontFamily: "'Bebas Neue', 'Impact', sans-serif",
    fontSize: `calc(${height} * 0.5)`,
    fontWeight: 400,
    letterSpacing: '0.05em',
    color: textColor,
    textTransform: 'uppercase',
    lineHeight: 1,
  };

  return (
    <div style={containerStyle} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="339"
        height="359"
        viewBox="0 0 339 359"
        style={{ height, width: 'auto', flexShrink: 0 }}
      >
        <path
          fill={primaryColor}
          d="M163.6 5.9a159 159 0 0 1 113.7 45l1.6 1.6 1.6 1.5c2 2 3.4 3.9 4.6 6.5-.1 2.5-.1 2.5-2 4.9L280 68a666.1 666.1 0 0 0-7.3 6.9l-2 1.9c-3.9 3.6-7.8 7.1-11.8 10.5l-9.7 8.8c-2.5 2.1-4.3 3.7-7.6 4.3-3.7-.6-4.8-2.2-7.3-5A81.8 81.8 0 0 0 194 73l-2.7-.7A101.6 101.6 0 0 0 130 79l-3.5 1.6A108 108 0 0 0 104 95l-3 2.4a63.4 63.4 0 0 0-8.5 9.3l-1.5 1.9c-15.8 20.9-21.3 44.3-21.4 70.2v2.1A105 105 0 0 0 95 252l2 2.5a97.3 97.3 0 0 0 62.4 32.2 100 100 0 0 0 75.1-22.4c3-2.7 5.4-5.6 7.8-8.8 2.5-2.2 4.3-2.5 7.7-2.5 2.5 1.6 2.5 1.6 4.9 4l2.6 2.5 2.5 2.5 4 3.5 11.6 10.3c2.1 2 4.4 3.9 6.6 5.8A96 96 0 0 1 293 293c-1.5 5.1-4.6 8-8.3 11.7l-2 1.9a167.4 167.4 0 0 1-119.4 45.6c-39-1-75.1-17.4-103.3-44.2l-1.6-1.5A169.7 169.7 0 0 1 4.8 189v-2.2c-.4-53.7 16-98.1 54-136.8A157.7 157.7 0 0 1 163.6 5.9Z"
        />
        <path
          fill={accentColor}
          d="M324.9 87.3c3.7.8 5 1.6 7.1 4.7 1.1 3.4 1.3 5.2 0 8.6-2.8 4.8-6.2 9-9.6 13.5l-2.2 2.8a3061.3 3061.3 0 0 1-9 11.7l-16 20.7L280 169l-22.2 28.7L249 209l-1.7 2.2a23022.1 23022.1 0 0 0-20.9 26.8c-17.9 23-17.9 23-25.8 24.7-11.8-2.3-23.3-20.1-30.5-29-2.1-2.7-4.3-5.2-6.6-7.7-3-3.3-6-6.7-8.8-10.2-3.6-4.5-7.3-8.8-11-13.2L130.8 188l-1.4-1.6a26.8 26.8 0 0 1-7-12.1c1-5.8 5-9.6 8.9-13.7 3.5-2 6.7-2.2 10.6-1.5 2.6 1.6 4.4 3 6.6 5.1l1.7 1.6a444.7 444.7 0 0 1 9.7 9l7.7 7.2c3 2.9 6.1 5.6 9.3 8.4 1.7 1.4 3.2 2.9 4.8 4.4l1.5 1.4 4.2 4c2.2 2.1 2.2 2.1 4.4 1.7 2.4-1 3.7-2 5.5-3.7l1.9-1.8 2-2a4408 4408 0 0 1 6-5.7c2.5-2.4 5.2-4.7 7.8-7l6.9-6.1a829 829 0 0 1 11-9.7l9.6-8.6a537 537 0 0 1 6.3-5.6l12.4-11.2c2.2-2 4.4-4 6.6-5.8l10.1-9.1c4-3.6 7.9-7.2 12-10.7l7.5-6.8L311 96l2.5-2.2c6.5-5.6 6.5-5.6 11.4-6.5Z"
        />
      </svg>
      <span style={textStyle}>Checkademic</span>
    </div>
  );
};
